import React from 'react';
import { Link } from 'gatsby';
import Img from 'gatsby-image';
import tw from 'twin.macro';
import Content from './Content';

export default ({ node, linkPrefix, img }) => (
  <Link to={`/${linkPrefix}/${node.slug.current}`}>
    <div
      css={tw`flex flex-col items-center justify-between px-3 py-10 mb-8 border rounded-md shadow-md sm:px-2 sm:px-6 sm:flex-row border-brand-lightGray`}
    >
      <div
        css={tw`flex flex-col items-center text-center sm:flex-row sm:text-left`}
      >
        <div>
          <Img fluid={img} css={tw`w-24 h-24 rounded-full`} />
        </div>
        <div css={tw`sm:ml-8`}>
          <h2
            className="underlined"
            css={tw`my-6 font-serif text-2xl sm:text-3xl sm:my-0`}
          >
            {node.title}
          </h2>
          <Content content={node._rawExcerpt} small css={tw`max-w-4xl`} />
        </div>
      </div>
      {node.price && (
        <div>
          <h3 className="underlined" css={tw`mt-12 font-serif sm:mt-0`}>
            ab <span css={tw`text-4xl`}>{node?.price}</span>€
          </h3>
        </div>
      )}
    </div>
  </Link>
);
